import { render, staticRenderFns } from "./SvgIcons.vue?vue&type=template&id=0077b0b0&"
import script from "./SvgIcons.vue?vue&type=script&lang=js&"
export * from "./SvgIcons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports